import React, { useMemo } from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import useDocumentDirection from '../hooks/useDocumentDirection';

let ltrCache;
let rtlCache;

function getCache(direction) {
  if (direction === 'rtl') {
    if (!rtlCache) {
      rtlCache = createCache({
        key: 'mui-rtl',
        stylisPlugins: [prefixer, rtlPlugin],
      });
    }
    return rtlCache;
  }
  if (!ltrCache) {
    ltrCache = createCache({ key: 'mui', stylisPlugins: [prefixer] });
  }
  return ltrCache;
}

/**
 * Provides an emotion cache configured with `stylis-plugin-rtl` whenever the
 * current i18n language is RTL. This is what lets MUI / sx physical CSS
 * (`left`, `right`, `marginLeft`, `paddingRight`, `textAlign: 'left'`, etc.)
 * auto-flip in Arabic and other RTL locales. Without it `theme.direction =
 * 'rtl'` only nudges a handful of MUI components.
 */
export default function RtlCacheProvider({ children }) {
  const direction = useDocumentDirection();
  const cache = useMemo(() => getCache(direction), [direction]);
  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
